export const iconFontAwesomeMapsImage = (
	<i className="fa-solid fa-image"></i>
);
